import * as STRING from './String'
import * as SECRET from './Secret'
import * as COLOR from './Color'
import * as EMAIL from './Email'
import * as URL from './Url'
import * as PHONE from './Phone'
import * as INTEGER from './Integer'
import * as CURRENCY from './Currency'
import * as DOUBLE from './Double'
import * as PERCENT from './Percent'
import * as TEXTAREA from './TextArea'
import * as BOOLEAN from './Boolean'
import * as RADIO from './Radio'
import * as COMBOBOX from './Combobox'
import * as PICKLIST from './Picklist'
import * as DATE from './Date'
import * as DATETIME from './DateTime'
import * as MULTIPICKLIST from './MultiPicklist'
import * as ID from './Id'
import * as IMAGE from './Image'
import * as REFERENCE from './Reference'
import * as MULTIREFERENCE from './MultiReference'
import * as CUSTOM from './Custom'
import * as RANGE from './Range'
const TIME = DATETIME

export default {
  STRING,
  SECRET,
  COLOR,
  EMAIL,
  URL,
  PHONE,
  INTEGER,
  DOUBLE,
  PERCENT,
  TEXTAREA,
  BOOLEAN,
  RADIO,
  COMBOBOX,
  PICKLIST,
  DATE,
  DATETIME,
  CURRENCY,
  TIME,
  MULTIPICKLIST,
  ID,
  IMAGE,
  REFERENCE,
  MULTIREFERENCE,
  POLYREFERENCE: REFERENCE,
  POLYMULTIREFERENCE: MULTIREFERENCE,
  CUSTOM,
  RANGE
}
